import { AUTH_FLOWS, DEFAULT_AUTH_FLOW } from 'const/constants'
import { authFlow } from 'const/session'
import type { AuthFlowType } from 'typings/Auth'
import { getCookie } from 'helpers/cookie'
import { getAppSessionItem } from '../appSessionItem'

/*
 * helper that matches the value from external storage to a known authFlow constant
 * ensures safety of the string value as a defined value
 */
const matchValueToAuthFlow = (
  flowFromExternalStore: string
): AuthFlowType | undefined => {
  return AUTH_FLOWS.find((flow) => flow === flowFromExternalStore)
}

/**
 * Gets valid authFlow value from from either session storage, cookie,
 * or default auth flow if neither of the previous ones existed
 * @returns {AuthFlowType} authFlow string ex. 'paylater'
 * @default DEFAULT_AUTH_FLOW
 */
const getSessionAuthFlow = (): AuthFlowType => {
  const sessionMatchingAuthFlow = matchValueToAuthFlow(
    getAppSessionItem(authFlow)
  )
  const cookieMatchedAuthFlow = matchValueToAuthFlow(getCookie(authFlow))

  return sessionMatchingAuthFlow || cookieMatchedAuthFlow || DEFAULT_AUTH_FLOW
}

export default getSessionAuthFlow
